import { useState } from 'react';

const LEDBlinkPopupHOC = (Component: any) =>
  function Comp(props: any) {
    const [showLEDBlinkPopup, setShowLEDBlinkPopup] = useState<boolean>(false);

    const addToggleHandler = () => {
      setShowLEDBlinkPopup(!showLEDBlinkPopup);
    };

    return (
      <Component
        showLEDBlinkPopup={showLEDBlinkPopup}
        addToggleHandler={addToggleHandler}
        {...props}
      />
    );
  };

export default LEDBlinkPopupHOC;
